import React from 'react';
import { Settings, AlertCircle } from 'lucide-react';

/**
 * Компонент секции дополнительных параметров расчета теплопотерь
 */
const AdditionalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Settings className="w-5 h-5 mr-2 text-blue-500" />
        Дополнительные параметры
      </h3>
      
      <div className="space-y-3">
        {/* Температурный фактор */}
        <div className="flex items-center">
          <input
            type="checkbox"
            id="includeTemperatureFactor"
            name="includeTemperatureFactor"
            checked={formData.includeTemperatureFactor}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <label htmlFor="includeTemperatureFactor" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Учитывать температурный фактор
            <span className="inline-block ml-1 text-gray-500 dark:text-gray-400">(рекомендуется)</span>
          </label>
        </div>
        <p className="text-xs text-gray-500 dark:text-gray-400 ml-6">
          Поправка на неравномерность распределения температур в помещении
        </p>
        
        {/* Тепловые мосты */}
        <div className="flex items-center">
          <input
            type="checkbox"
            id="includeThermalBridges"
            name="includeThermalBridges"
            checked={formData.includeThermalBridges}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <label htmlFor="includeThermalBridges" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Учитывать тепловые мосты
            <span className="inline-block ml-1 text-gray-500 dark:text-gray-400">(рекомендуется)</span>
          </label>
        </div>
        <p className="text-xs text-gray-500 dark:text-gray-400 ml-6">
          Увеличение теплопотерь через конструктивные элементы с повышенной теплопроводностью
        </p>
        
        {/* Инфильтрационные потери */}
        <div className="flex items-center">
          <input
            type="checkbox"
            id="includeInfiltrationLoss"
            name="includeInfiltrationLoss"
            checked={formData.includeInfiltrationLoss}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <label htmlFor="includeInfiltrationLoss" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Учитывать инфильтрацию через ограждающие конструкции
            <span className="inline-block ml-1 text-gray-500 dark:text-gray-400">(рекомендуется)</span>
          </label>
        </div>
        <p className="text-xs text-gray-500 dark:text-gray-400 ml-6">
          Дополнительные теплопотери за счет проникновения холодного воздуха через неплотности
        </p>
      </div>
      
      <div className="mt-4 p-3 rounded-lg bg-blue-100 dark:bg-blue-900/30 border border-blue-200 dark:border-blue-700">
        <div className="flex items-start">
          <AlertCircle className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              Рекомендации по точности расчета
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              Для получения наиболее точных результатов рекомендуется включить все дополнительные параметры.
              Это позволит учесть не только прямые теплопотери через ограждающие конструкции, но и дополнительные
              факторы, которые могут значительно влиять на общий тепловой баланс здания.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalParametersSection;